<fieldset class="group" [formGroup]="group()">
    <legend>{{ "FLIGHT_LIST.groups.passengers" | translate }}</legend>
    <div class="fields">
        <label class="field">
            <span class="label">{{ "FLIGHT_LIST.passengers" | translate }}</span>
            <kendo-numerictextbox formControlName="passengers" format="#" [decimals]="0" [min]="0" [spinners]="false"></kendo-numerictextbox>
        </label>
        <label class="field">
            <span class="label">{{ "FLIGHT_LIST.payingPassengers" | translate }}</span>
            <kendo-numerictextbox formControlName="payingPassengers" format="#" [decimals]="0" [min]="0" [spinners]="false"></kendo-numerictextbox>
        </label>
        <label class="field check">
            <input type="checkbox" kendoCheckBox formControlName="isTax" />
            <span class="label">{{ "FLIGHT_LIST.isTax" | translate }}</span>
        </label>
    </div>
</fieldset>
